import {ReportType} from '../reports/constants';

export function isInternReport(type: string) {
  return (
    type === String(ReportType.SPRING) ||
    type === String(ReportType.SUMMER) ||
    type === String(ReportType.AUTUMN) ||
    type === String(ReportType.WINTER) ||
    type === String(ReportType.INTERN)
  );
}
